import QuoteLoading from './QuoteLoading/QuoteLoading';
import OverlaySpinner from './OverlaySpinner/OverlaySpinner';
import Label from './Label/Label';
import BuildQuote from './BuildQuote/BuildQuote';

const LoadingIndicators = {
  QuoteLoading,
  OverlaySpinner,
  Label,
  BuildQuote,
};

export default LoadingIndicators;
